module.exports = __webpack_public_path__ + "media/assets/plane-8-color-b340d46b1764f11cb84c493d7515cc31.svg";